import { PROJECT_ID } from "config/keys/user";
import { getApp } from "firebase/app";
import { getFunctions, httpsCallable } from "firebase/functions";
import { REGION } from "store/ref";

const app = getApp(PROJECT_ID);
const functions = getFunctions(app, REGION);

// get functions api.
export const getApiFunctions = () => {
  // :::::::::::: LOGIN :::::::::::::://

  // login operator.
  const login = httpsCallable(functions, "api-operator-login-token");

  // generate token,
  const generateToken = httpsCallable(
    functions,
    "api-login-bailiff-token-generate",
  );

  // hàm add pin code.
  const emailSendCode = httpsCallable(
    functions,
    "api-email-verification-add-pincode",
  ); // { email, source },
  const emailCheckCode = httpsCallable(
    functions,
    "api-email-verification-check-pincode",
  ); // { email, source, pincode},

  // search email.
  const searchUserEmail = httpsCallable(functions, "api-manager-search-email"); // {email}
  const searchUserId = httpsCallable(functions, "api-manager-scan-id"); // {id}

  const addSupporters = httpsCallable(functions, "api-manager-add-supporter"); //{id, supporters}
  const updateSupporters = httpsCallable(
    functions,
    "api-manager-update-supporter",
  ); //{id, supporters}
  const deleteSupporters = httpsCallable(
    functions,
    "api-manager-delete-supporter",
  ); //{id}

  // return.
  return {
    login,
    generateToken,
    email: {
      emailSendCode,
      emailCheckCode,
    },
    manager: {
      searchUserEmail,
      searchUserId,
      addSupporters,
      updateSupporters,
      deleteSupporters,
    },
  };
};
